import React, { useCallback, useEffect, useRef, useState } from 'react';

import { BORDER_RADIUS } from '@app/style/constants';
import wipIMG from '@assets/general/wip.png';
import { getClients } from '@FW/api/main.api';
import { Container } from '@shared/styled/Container';
import { Image, Progress, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { useNavigate } from 'react-router-dom';

const { Text } = Typography;
const TIMEOUT = 30; // seconds

const MaintenanceMode = () => {
	const [timeLeft, setTimeLeft] = useState(TIMEOUT);
	const timerRef = useRef<NodeJS.Timeout>(null);

	const navigate = useNavigate();

	const tryFetchClientData = useCallback(() => {
		getClients()
			.then(() => {
				navigate('/');
			})
			.catch((err) => console.error(err));
	}, []);

	// (re)start the countdown
	const startTimer = useCallback(() => {
		// reset
		setTimeLeft(TIMEOUT);
		// clear any existing
		if (timerRef.current) clearInterval(timerRef.current);

		timerRef.current = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					clearInterval(timerRef.current!);
					tryFetchClientData();
					startTimer(); // restart
					return TIMEOUT;
				}
				return prev - 1;
			});
		}, 1000);
	}, [tryFetchClientData]);

	useEffect(() => {
		tryFetchClientData(); // initial
		startTimer();
		return () => {
			if (timerRef.current) clearInterval(timerRef.current);
		};
	}, [tryFetchClientData, startTimer]);

	const percent = (timeLeft / TIMEOUT) * 100;

	return (
		<Container align='center' vertical gap={16}>
			<Image preview={false} src={wipIMG} style={{ maxWidth: 750, borderRadius: BORDER_RADIUS }} />
			<Title level={2}>Ведуться технічні роботи з оновлення сайту</Title>
			<Text className='text-gray'>Спробуємо ще раз через:</Text>
			<Progress
				status={timeLeft === TIMEOUT ? 'exception' : 'success'}
				type='circle'
				percent={Math.round(percent)}
				format={() => `${timeLeft}c`}
			/>
		</Container>
	);
};

export default MaintenanceMode;
